import NextImage from 'next/image'
import LazyLoad from 'react-lazyload'
import { getLink } from '@helpers/env'
import styles from './styles.module.scss'

type CardMinimalProps = {
  title: string
  image: string
  url: string
}

function CardMinimal({ title, image, url }: CardMinimalProps) {
  return (
    <div className={styles.cardMinimal}>
      <a href={getLink(url)}>
        <div className={styles.cardMinimal_image}>
          <LazyLoad height={435} once>
            <NextImage src={image} alt={title} width="285" height="435" />
          </LazyLoad>
        </div>
        <div className={styles.cardMinimal_titleWrapper}>
          <h3 className={styles.cardMinimal_title}>{title}</h3>
        </div>
      </a>
    </div>
  )
}

export default CardMinimal
